import { SuppliesQuoteRequestSource } from "@redotech/cockroachdb-codegen/tables/supplies-quote-request-source";
import * as z from "zod";

export const submitSuppliesQuoteRequest = {
  name: "submitSuppliesQuoteRequest" as const,
  input: z.object({
    email: z.email().optional(),
    message: z.string().max(5000).optional(),
    attachment: z
      .object({
        url: z.url(),
        filename: z.string().max(512),
        contentType: z.string().max(255),
      })
      .optional(),
    source: z.enum(SuppliesQuoteRequestSource),
  }),
  output: z.object({ success: z.boolean() }),
};
